import { getRegisterFunction } from '../../utils/register.js';
import { OneUxEditableTextElement } from './OneUxEditableTextElement.js';
export const register = getRegisterFunction(OneUxEditableTextElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-editable-text': OneUxEditableTextElement;
    "editable-text-0de68a2158b28948fb84ab25b816ce14": OneUxEditableTextElement;
  }
}